import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line\">\n<path id=\"icon-line_Rectangle 5124\" d=\"M25 1L1 25\" stroke=\"currentColor\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol